<template>
  <div class="profit">
    <img class="pros" :src="imgs.op1" alt="">
    <img class="pros" :src="imgs.op2" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgs: {
        op1: require('../../assets/invo/finish1.png'),
        op2: require('../../assets/invo/finish2.png')
      }
    }
  },
  components: {
  },
}
</script>

<style lang="scss" scoped>
.profit {
    text-align: center;
  .pros {
    width: 100%;
    margin: -2px 0;
  }
}
</style>